// aldoo-ra/Admin/routes.js
import AdminHome from "aldoo-ra/Admin/Home"
import CMS from "aldoo-ra/CMS"
import Blog from "aldoo-ra/Admin/Blog"
import Store from "aldoo-ra/Admin/Store"
import Backups from "aldoo-ra/Backups"
import LocalizationEditor from "aldoo-ra/Localization/localization-editor"
import MailTemplates from "aldoo-ra/Admin/MailTemplates"
import Updates from "aldoo-ra/Admin/Updates"
import Environments from "aldoo-ra/Admin/Updates/Environments"
import Install from "aldoo-ra/Admin/install"
import SignIn from "aldoo-ra/Admin/Signin"
import { adminRole } from "aldoo-ra/RBAC"
import Sitemap from "aldoo-ra/Admin/Sitemap"
import CustomerSupport from "aldoo-ra/Admin/CustomerSupport"
import SpamProtection from "aldoo-ra/Admin/SpamProtection"
import ProductLicensing from "aldoo-ra/Admin/ProductLicensing" // Add this import
import PlatformAccess from "aldoo-ra/Admin/PlatformAccess"
import ParamIO from "aldoo-ra/Admin/ParamIO"
import AdminLogs from "aldoo-ra/Admin/Logs"
import HistoryBrowser from "aldoo-ra/Admin/History"
import Newsletter from "aldoo-ra/Admin/Newsletter"
import NewsletterManagePage from "aldoo-ra/Admin/Newsletter/Pages/NewsletterManagePage"
import SiteTheme from "aldoo-ra/Admin/SiteTheme"
import Structure from "aldoo-ra/Admin/Structure"
import TaskManager from "aldoo-ra/Admin/TaskManager"
import FeatureMatrix from "aldoo-ra/Admin/FeatureMatrix"
import AdminMediaLibrary from "aldoo-ra/Admin/MediaLibrary"
import AgentsAdmin from "aldoo-ra/Admin/Agents"
import HelpCenter from "aldoo-ra/Admin/HelpCenter"
import Taxonomy from "aldoo-ra/Admin/Taxonomy"
import KPI from "aldoo-ra/Admin/KPI"

// adminRole is now imported from aldoo-ra/RBAC

//If a module specifies a routes.js, it can export an object
//where the keys are the paths and the values are the components
// Register all routes at once using an object
export default {
    "/admin": adminRole(AdminHome),
    "/admin/install": adminRole(Install),
    "/admin/cms*": adminRole(CMS),
    "/admin/blog*": adminRole(Blog),
    "/admin/store*": adminRole(Store),
    "/admin/backups": adminRole(Backups),
    "/admin/localization*": adminRole(LocalizationEditor),
    "/admin/mail-templates*": adminRole(MailTemplates),
    "/admin/updates*": adminRole(Updates),
    "/admin/environments": adminRole(Environments),
    "/admin/sitemap*": adminRole(Sitemap),
    "/admin/customer-support*": adminRole(CustomerSupport),
    "/admin/spam-protection*": adminRole(SpamProtection),
    "/admin/product-licensing*": adminRole(ProductLicensing), // Add this route
    "/admin/platform-access*": adminRole(PlatformAccess),
    "/admin/paramio*": adminRole(ParamIO),
    "/admin/logs*": adminRole(AdminLogs),
    "/admin/changes*": adminRole(HistoryBrowser),
    "/admin/newsletter*": adminRole(Newsletter),
    "/newsletter": NewsletterManagePage,
    "/admin/site-theme*": adminRole(SiteTheme),
    "/admin/structure*": adminRole(Structure),
    "/admin/task-manager*": adminRole(TaskManager),
    "/admin/feature-matrix*": adminRole(FeatureMatrix),
    "/admin/media-library*": adminRole(AdminMediaLibrary),
    "/admin/agents*": adminRole(AgentsAdmin),
    "/admin/help-center*": adminRole(HelpCenter),
    "/admin/taxonomy*": adminRole(Taxonomy),
    "/admin/kpi*": adminRole(KPI),
    "/admin/sign-in": SignIn,
}